import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import SEO from '../../common/SEO';
import GoogleMaps from '../../components/GoogleMaps';
import ServicesNavigationFooter from '../../components/ServicesNavigationFooter';
import RelatedTopics from '../../components/RelatedTopics';
import * as FiIcons from 'react-icons/fi';

const { 
  FiArrowLeft, FiCheckCircle, FiShield, FiFileText, 
  FiHome, FiDollarSign, FiMapPin, FiCheck, 
  FiInfo, FiLayers, FiTool, FiBriefcase, FiHelpCircle
} = FiIcons;

function UnverbindlichesAngebot() {
  const articleSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LocalBusiness",
        "@id": "https://ausbau.nrw/#mk-ausbau",
        "name": "MK-Ausbau",
        "description": "Innenausbau und Sanierung in NRW: Trockenbau, Dämmung (Stroh bis Glaswolle), Malerarbeiten, Bodenbeläge, Innentürmontage sowie PU-3D-Designböden. Einsatzgebiet: Kreis Heinsberg, Niederrhein und Großraum Düsseldorf.",
        "url": "https://ausbau.nrw/",
        "logo": "https://ausbau.nrw/logo-icon.svg",
        "telephone": "+4924528607038",
        "email": "info@ausbau.nrw",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Am Diebsweg 17",
          "postalCode": "52525",
          "addressLocality": "Heinsberg",
          "addressRegion": "NRW",
          "addressCountry": "DE"
        },
        "areaServed": [
          { "@type": "City", "name": "Heinsberg" },
          { "@type": "City", "name": "Erkelenz" },
          { "@type": "City", "name": "Hückelhoven" },
          { "@type": "City", "name": "Dremmen" },
          { "@type": "City", "name": "Gangelt" },
          { "@type": "City", "name": "Geilenkirchen" },
          { "@type": "City", "name": "Übach-Palenberg" },
          { "@type": "City", "name": "Wassenberg" },
          { "@type": "City", "name": "Wegberg" },
          { "@type": "City", "name": "Düsseldorf" },
          { "@type": "City", "name": "Mönchengladbach" },
          { "@type": "City", "name": "Viersen" },
          { "@type": "City", "name": "Neuss" }
        ],
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [ "Monday", "Tuesday", "Wednesday", "Thursday", "Friday" ],
            "opens": "07:00",
            "closes": "17:00"
          }
        ],
        "makesOffer": [
          { "@id": "https://ausbau.nrw/#offer-trockenbau" },
          { "@id": "https://ausbau.nrw/#offer-daemmung" },
          { "@id": "https://ausbau.nrw/#offer-maler" },
          { "@id": "https://ausbau.nrw/#offer-boden" },
          { "@id": "https://ausbau.nrw/#offer-innentueren" },
          { "@id": "https://ausbau.nrw/#offer-pu3d" }
        ]
      },
      {
        "@type": "Service",
        "@id": "https://ausbau.nrw/#service-trockenbau",
        "name": "Trockenbau",
        "serviceType": "Trockenbau",
        "provider": { "@id": "https://ausbau.nrw/#mk-ausbau" },
        "areaServed": [
          "Heinsberg","Erkelenz","Hückelhoven","Dremmen","Gangelt","Geilenkirchen","Übach-Palenberg","Wassenberg","Wegberg","Düsseldorf","Mönchengladbach","Viersen","Neuss"
        ],
        "description": "Trockenbau für Wände, Decken, Dachschrägen und Raumtrennung. Optional Schallschutz-/Brandschutzlösungen je nach Bauteil und Projekt."
      },
      {
        "@type": "Offer",
        "@id": "https://ausbau.nrw/#offer-trockenbau",
        "name": "Unverbindliches Angebot: Trockenbau",
        "itemOffered": { "@id": "https://ausbau.nrw/#service-trockenbau" },
        "availability": "https://schema.org/InStock",
        "url": "https://ausbau.nrw/kontakt",
        "priceSpecification": {
          "@type": "PriceSpecification",
          "priceCurrency": "EUR",
          "description": "Preis nach Besichtigung/Leistungsumfang. Unverbindliches Angebot."
        }
      },
      {
        "@type": "Service",
        "@id": "https://ausbau.nrw/#service-daemmung",
        "name": "Dämmung (Stroh bis Glaswolle)",
        "serviceType": "Dämmung",
        "provider": { "@id": "https://ausbau.nrw/#mk-ausbau" },
        "areaServed": [
          "Heinsberg","Erkelenz","Hückelhoven","Dremmen","Gangelt","Geilenkirchen","Übach-Palenberg","Wassenberg","Wegberg","Düsseldorf","Mönchengladbach","Viersen","Neuss"
        ],
        "description": "Dämmarbeiten im Innenausbau und Holzbau: Naturdämmung (z. B. Stroh) sowie klassische Dämmstoffe (z. B. Glaswolle) – abgestimmt auf Bauteil, Feuchte- und Luftdichtheitskonzept."
      },
      {
        "@type": "Offer",
        "@id": "https://ausbau.nrw/#offer-daemmung",
        "name": "Unverbindliches Angebot: Dämmung (Stroh bis Glaswolle)",
        "itemOffered": { "@id": "https://ausbau.nrw/#service-daemmung" },
        "availability": "https://schema.org/InStock",
        "url": "https://ausbau.nrw/kontakt",
        "priceSpecification": {
          "@type": "PriceSpecification",
          "priceCurrency": "EUR",
          "description": "Preis nach Besichtigung/Leistungsumfang. Unverbindliches Angebot."
        }
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Ist das Angebot wirklich unverbindlich?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ja. Sie bekommen eine transparente Einschätzung, ohne Verpflichtung."
            }
          },
          {
            "@type": "Question",
            "name": "Macht ihr auch kleinere Aufträge?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Je nach Auslastung und Anfahrt – im Kreis Heinsberg häufig ja. Für Düsseldorf/Neuss/MG/Viersen eher gebündelt oder ab sinnvoller Größenordnung."
            }
          },
          {
            "@type": "Question",
            "name": "Welche Dämmung ist besser – Stroh oder Glaswolle?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Das hängt vom Bauteil, Feuchte-/Luftdichtheitskonzept und Budget ab. Naturdämmung ist stark bei Ökologie/Sommerkomfort, Glaswolle oft wirtschaftlich und vielseitig."
            }
          },
          {
            "@type": "Question",
            "name": "Kann ich mehrere Leistungen kombinieren (z. B. Trockenbau + Maler + Boden)?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ja – Kombiangebote sind häufig sinnvoll, weil die Baustellenlogistik effizienter wird."
            }
          }
        ]
      }
    ]
  };

  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  return (
    <div className="py-20 bg-white">
      <SEO 
        title="Unverbindliches Angebot: Trockenbau & Dämmung NRW | MK-AUSBAU"
        description="Ehrliches Angebot für Innenausbau in Heinsberg, Düsseldorf & NRW. Trockenbau, Strohdämmung, Maler & Boden. Kostenlos anfragen!"
        keywords="Angebot Trockenbau NRW, Dämmung Angebot Heinsberg, Malerarbeiten Kosten Düsseldorf, Innenausbau Preise, Renovierung Angebot unverbindlich"
        schema={articleSchema}
        canonical="/blog/unverbindliches-angebot-innenausbau"
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-left">
        <Link 
          to="/blog" 
          className="inline-flex items-center text-mk-teal-600 hover:text-mk-teal-700 font-bold mb-8 transition-colors group"
        >
          <SafeIcon icon={FiArrowLeft} className="mr-2 w-5 h-5 group-hover:-translate-x-1 transition-transform" />
          Zurück zur Übersicht
        </Link>

        <motion.article {...fadeIn} className="prose prose-lg prose-mk max-w-none">
          {/* Header */}
          <header className="mb-12">
            <div className="flex items-center space-x-3 text-mk-teal-600 font-bold uppercase tracking-wider text-sm mb-4 text-left">
              <SafeIcon icon={FiFileText} />
              <span>Angebot & Service</span>
            </div>
            <h1 className="text-3xl md:text-5xl font-bold text-gray-900 leading-tight mb-6 text-left">
              Unverbindliches Angebot für Trockenbau, Dämmung & Innenausbau
            </h1>
            <p className="text-xl font-medium text-mk-teal-700 mb-6">
              Von Strohdämmung bis Glaswolle – regional stark in NRW
            </p>
            <div className="flex items-center space-x-4 text-gray-500 text-sm border-y border-gray-100 py-4">
              <span className="flex items-center"><SafeIcon icon={FiShield} className="mr-1" /> MK-Ausbau Service</span>
              <span className="flex items-center"><SafeIcon icon={FiInfo} className="mr-1" /> Region: NRW / Heinsberg</span>
            </div>
          </header>

          {/* Intro */}
          <div className="lead text-xl text-gray-600 leading-relaxed mb-12 text-left">
            Wer in Nordrhein-Westfalen baut, saniert oder modernisiert, steht oft vor der gleichen Frage:
            Wie bekomme ich ein <strong>unverbindliches, ehrliches Angebot</strong>, das wirklich zu meinem Projekt passt – ohne Verkaufsdruck und ohne unnötige Zusatzkosten?
          </div>

          <p className="text-gray-700">
            Ob Trockenbau, Dämmung von Stroh bis Glaswolle, Malerarbeiten, Bodenbeläge, Innentürmontage oder PU-3D-Designböden:
            Ein seriöses Angebot beginnt immer mit einer realistischen Einschätzung von Gebäude, Nutzung und Budget.
          </p>

          <p className="text-gray-700 font-medium mb-12">
            Genau darauf ist MK-Ausbau spezialisiert – mit Projekten im Kreis Heinsberg, am Niederrhein und im Großraum Düsseldorf.
          </p>

          {/* Warum wichtig */}
          <h2 className="text-3xl font-bold text-gray-900 mt-16 mb-6">Warum ein unverbindliches Angebot im Innenausbau so wichtig ist</h2>
          <p className="text-gray-700 mb-4">Jedes Projekt unterscheidet sich:</p>
          <ul className="space-y-2 list-none pl-0 mb-6">
            <li className="flex items-center"><SafeIcon icon={FiCheck} className="text-mk-teal-500 mr-2"/> Altbau oder Neubau</li>
            <li className="flex items-center"><SafeIcon icon={FiCheck} className="text-mk-teal-500 mr-2"/> massive Bauweise oder Holzbau</li>
            <li className="flex items-center"><SafeIcon icon={FiCheck} className="text-mk-teal-500 mr-2"/> energetische Sanierung oder reiner Innenausbau</li>
          </ul>
          <p className="text-gray-700 mb-6">
            Gerade in Regionen mit sehr unterschiedlicher Bausubstanz – etwa zwischen Heinsberg, Mönchengladbach, Viersen, Neuss und Düsseldorf – ist eine individuelle Bewertung entscheidend.
          </p>
          <div className="bg-mk-teal-50 p-6 rounded-xl border-l-4 border-mk-teal-500">
            <p className="font-bold text-mk-teal-900 mb-2">Ein unverbindliches Angebot schafft:</p>
            <div className="flex flex-wrap gap-4">
              <span className="bg-white px-3 py-1 rounded text-sm font-medium text-mk-teal-800 shadow-sm">Kostentransparenz</span>
              <span className="bg-white px-3 py-1 rounded text-sm font-medium text-mk-teal-800 shadow-sm">Planungssicherheit</span>
              <span className="bg-white px-3 py-1 rounded text-sm font-medium text-mk-teal-800 shadow-sm">Entscheidungsfreiheit</span>
            </div>
          </div>

          {/* Trockenbau */}
          <h2 className="text-3xl font-bold text-gray-900 mt-16 mb-6 flex items-center">
            <SafeIcon icon={FiLayers} className="mr-3 text-mk-teal-600" />
            Trockenbau: Flexible Lösungen für Wohnungen & Häuser in NRW
          </h2>
          <p className="text-gray-700 mb-6">
            Ob Einfamilienhaus in Erkelenz, Wohnung in Neuss, Sanierungsobjekt in Mönchengladbach oder Dachgeschossausbau in Düsseldorf – Trockenbau ist die Grundlage moderner Raumgestaltung:
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8 list-none pl-0">
            {['Trennwände', 'Abgehängte Decken', 'Dachschrägen', 'Schall- und Brandschutz'].map((item, i) => (
              <li key={i} className="bg-gray-50 p-3 rounded-lg flex items-center text-gray-700 font-medium">
                <SafeIcon icon={FiCheckCircle} className="text-mk-teal-500 mr-2" /> {item}
              </li>
            ))}
          </ul>
          <p className="text-gray-700">Durch saubere Planung lassen sich Räume schnell, effizient und wirtschaftlich anpassen.</p>

          {/* Dämmung */}
          <h2 className="text-3xl font-bold text-gray-900 mt-16 mb-6 flex items-center">
            <SafeIcon icon={FiTool} className="mr-3 text-mk-teal-600" />
            Dämmung: Von Stroh bis Glaswolle
          </h2>
          <p className="text-gray-700 mb-6">
            Nicht jede Dämmung passt zu jedem Gebäude. Deshalb umfasst das Leistungsspektrum bewusst natürliche und klassische Dämmstoffe:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            <div className="border border-green-200 bg-green-50 p-6 rounded-xl">
              <h3 className="text-lg font-bold text-green-800 mb-3">Natürliche Dämmung (z. B. Stroh)</h3>
              <ul className="text-sm space-y-2 text-green-900">
                <li>• ideal für Holzbau & ökologische Projekte</li>
                <li>• sehr guter Sommerkomfort</li>
                <li>• CO₂-bindend & kreislauffähig</li>
              </ul>
            </div>
            <div className="border border-gray-200 bg-gray-50 p-6 rounded-xl">
              <h3 className="text-lg font-bold text-gray-800 mb-3">Klassische Dämmung (z. B. Glaswolle)</h3>
              <ul className="text-sm space-y-2 text-gray-700">
                <li>• bewährt im Dach- und Innenausbau</li>
                <li>• gutes Preis-Leistungs-Verhältnis</li>
                <li>• vielseitig einsetzbar</li>
              </ul>
            </div>
          </div>
          <p className="text-gray-700">
            Ob Altbau in Gangelt, Neubau in Viersen oder Sanierung in Wassenberg – entscheidend ist, was technisch sinnvoll und langfristig haltbar ist.
          </p>

          {/* Malerarbeiten */}
          <h2 className="text-3xl font-bold text-gray-900 mt-16 mb-6">Malerarbeiten: Saubere Oberflächen</h2>
          <p className="text-gray-700 mb-4">
            Nach Trockenbau oder Dämmung sorgen fachgerechte Malerarbeiten für das finale Erscheinungsbild:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
            <li>Spachtel- und Glättarbeiten</li>
            <li>moderne Farbkonzepte</li>
            <li>Renovierung von Bestandsflächen</li>
          </ul>
          <p className="text-gray-700">
            Gerade in Wohnräumen und Mietobjekten in Düsseldorf, Neuss oder Mönchengladbach ist eine saubere Ausführung entscheidend für Wertigkeit und Wohngefühl.
          </p>

          {/* Boden & PU */}
          <h2 className="text-3xl font-bold text-gray-900 mt-16 mb-6">Bodenbeläge & PU-3D-Designböden</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            <div>
              <h3 className="font-bold text-xl text-gray-900 mb-3">Klassische Bodenbeläge</h3>
              <ul className="list-disc pl-5 space-y-1 text-gray-700 mb-3">
                <li>Vinyl & Designboden</li>
                <li>Laminat</li>
              </ul>
              <p className="text-sm text-gray-500">Funktionale Lösungen für Wohn- und Gewerberäume.</p>
            </div>
            <div>
              <h3 className="font-bold text-xl text-gray-900 mb-3">PU-3D-Designböden</h3>
              <ul className="list-disc pl-5 space-y-1 text-gray-700 mb-3">
                <li>fugenlos</li>
                <li>pflegeleicht</li>
                <li>modern & langlebig</li>
              </ul>
              <p className="text-sm text-gray-500">Beliebt in modernen Wohnhäusern in Wegberg und Gewerbeflächen.</p>
            </div>
          </div>

          {/* Innentüren */}
          <h2 className="text-3xl font-bold text-gray-900 mt-16 mb-6">Innentürmontage: Der Abschluss</h2>
          <p className="text-gray-700 mb-4">Neue Innentüren sorgen für:</p>
          <div className="flex flex-wrap gap-3 mb-6">
            <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm font-medium">klare Raumtrennung</span>
            <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm font-medium">Schallschutz</span>
            <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm font-medium">stimmiges Gesamtbild</span>
          </div>
          <p className="text-gray-700">
            Gerade nach Sanierungen oder Grundrissänderungen – etwa in Wohnungen in Neuss oder Einfamilienhäusern in Hückelhoven – ist eine präzise Montage entscheidend.
          </p>

          {/* Städte Liste */}
          <h2 className="text-3xl font-bold text-gray-900 mt-16 mb-6 flex items-center">
            <SafeIcon icon={FiMapPin} className="mr-3 text-mk-teal-600" />
            In diesen Städten ist ein unverbindliches Angebot möglich
          </h2>
          <p className="text-gray-700 mb-6">MK-Ausbau ist regelmäßig tätig in:</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mb-8">
            <div>
              <h4 className="font-bold text-mk-teal-700 mb-3 border-b border-mk-teal-100 pb-2">Kreis Heinsberg & Umgebung</h4>
              <ul className="grid grid-cols-2 gap-2 text-sm text-gray-700">
                <li>• Heinsberg</li>
                <li>• Erkelenz</li>
                <li>• Hückelhoven</li>
                <li>• Dremmen</li>
                <li>• Gangelt</li>
                <li>• Geilenkirchen</li>
                <li>• Übach-Palenberg</li>
                <li>• Wassenberg</li>
                <li>• Wegberg</li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-mk-teal-700 mb-3 border-b border-mk-teal-100 pb-2">Niederrhein & Großraum NRW</h4>
              <ul className="text-sm text-gray-700 space-y-1">
                <li>• Mönchengladbach</li>
                <li>• Viersen</li>
                <li>• Neuss</li>
                <li>• Düsseldorf</li>
              </ul>
            </div>
          </div>
          <p className="text-gray-700 text-sm italic bg-gray-50 p-4 rounded-lg">
            Diese regionale Abdeckung ermöglicht kurze Wege, realistische Termine und Erfahrung mit sehr unterschiedlichen Gebäudetypen – vom ländlichen Einfamilienhaus bis zur Stadtwohnung.
          </p>

          {/* Fazit */}
          <div className="bg-mk-teal-600 text-white p-8 rounded-2xl shadow-xl mt-16 mb-12">
            <h2 className="text-white text-2xl font-bold mb-4 mt-0">Fazit</h2>
            <p className="text-mk-teal-50 mb-4">
              Ein unverbindliches Angebot im Innenausbau sollte Orientierung geben – nicht unter Druck setzen.
            </p>
            <p className="text-white font-medium">
              Ob Trockenbau, Dämmung von Stroh bis Glaswolle, Malerarbeiten, Bodenbelag, Innentüren oder PU-3D-Designböden:
              <br/><br/>
              👉 <strong>Der erste Schritt ist immer eine ehrliche, fachliche Einschätzung – angepasst an Gebäude, Region und Budget.</strong>
            </p>
          </div>

          {/* FAQ Section */}
          <div className="mt-20 pt-12 border-t border-gray-200">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Häufige Fragen zum unverbindlichen Angebot
            </h2>
            <div className="space-y-4">
              {[
                {
                  q: "Ist das Angebot wirklich unverbindlich?",
                  a: "Ja. Sie bekommen eine transparente Einschätzung, ohne Verpflichtung."
                },
                {
                  q: "Macht ihr auch kleinere Aufträge?",
                  a: "Je nach Auslastung und Anfahrt – im Kreis Heinsberg häufig ja. Für Düsseldorf/Neuss/MG/Viersen eher gebündelt oder ab sinnvoller Größenordnung."
                },
                {
                  q: "Welche Dämmung ist besser – Stroh oder Glaswolle?",
                  a: "Das hängt vom Bauteil, Feuchte-/Luftdichtheitskonzept und Budget ab. Naturdämmung ist stark bei Ökologie/Sommerkomfort, Glaswolle oft wirtschaftlich und vielseitig."
                },
                {
                  q: "Kann ich mehrere Leistungen kombinieren (z. B. Trockenbau + Maler + Boden)?",
                  a: "Ja – Kombiangebote sind häufig sinnvoll, weil die Baustellenlogistik effizienter wird."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-gray-50 rounded-xl p-6 hover:bg-mk-teal-50 transition-colors cursor-default">
                  <h3 className="font-bold text-gray-900 mb-2 flex items-start">
                    <SafeIcon icon={FiHelpCircle} className="text-mk-teal-500 mt-1 mr-3 flex-shrink-0" />
                    {faq.q}
                  </h3>
                  <p className="text-gray-700 text-sm ml-8 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="text-center py-12 mt-12 border-t border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Jetzt unverbindlich anfragen</h3>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Lassen Sie uns über Ihr Projekt sprechen. Wir erstellen Ihnen gerne ein individuelles Angebot.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/kontakt"
                className="bg-mk-teal-500 hover:bg-mk-teal-600 text-white px-8 py-4 rounded-sm font-bold transition-all shadow-lg flex items-center justify-center"
              >
                Angebot anfordern
              </Link>
              <Link
                to="/services"
                className="bg-mk-red-700 hover:bg-mk-red-800 text-white px-8 py-4 rounded-sm font-bold transition-all shadow-lg flex items-center justify-center"
              >
                Alle Leistungen
              </Link>
            </div>
          </div>
        </motion.article>
      </div>

      <RelatedTopics />
      <ServicesNavigationFooter />
      <GoogleMaps />
    </div>
  );
}

export default UnverbindlichesAngebot;